export const InpuStyle = {
  baseStyle: {},
  sizes: {},
  variants: {
    filled: {
      field: {
        borderRadius: "none",
        _focus: {
          borderColor: "purple.500",
        },
        _active: {
          borderColor: "purple.500",
        },
      },
    },
  },
  defaultProps: {},
};
